/*=========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
==========================================================================================*/


import state from './moduleCompanyManagementState.js'
import mutations from './moduleCompanyManagementMutations.js'
import actions from './moduleCompanyManagementActions.js'
import getters from './moduleCompanyManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

